import { render } from "./PatientMedicationTable.vue?vue&type=template&id=7cc8c8b8"
import script from "./PatientMedicationTable.vue?vue&type=script&lang=js"
export * from "./PatientMedicationTable.vue?vue&type=script&lang=js"

import "./PatientMedicationTable.vue?vue&type=style&index=0&id=7cc8c8b8&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__